module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-code-035d5803.svg";